module.exports = __webpack_public_path__ + "static/media/sad404.ffc1ba45.svg";